import { translate as t } from "../../../../../infrastructure/translate/localization";

export const COLUMNS = [
  {
    id: "internalId",
    label: t("common-messages.internal-id"),
  },
  {
    id: "name",
    label: t("common-messages.name"),
    searchable: true,
  },
  {
    id: "surname",
    label: t("common-messages.surnames"),
    searchable: true,
  },
  {
    id: "email",
    label: t("common-messages.email"),
    searchable: true,
  },
  { id: "benefitPlanName", label: t("benefits-section.benefit-plan") },
  {
    id: "legalId",
    label: t("common-messages.legal-id"),
    searchable: true,
  },
  { id: "warning", label: t("common-messages.review") },
  {
    id: "actions",
    label: "",
  },
];

export const getColumns = ({
  category,
}: {
  category: string;
}): { id: string; label: string; searchable?: boolean }[] => {
  if (category === "error") {
    return COLUMNS.map((column) =>
      column.id === "warning"
        ? { id: category, label: t("common-messages.errors") }
        : column
    );
  }
  return COLUMNS;
};

export const keys = COLUMNS.filter(({ searchable }) => searchable).reduce(
  (acc, { id }) => ({ ...acc, [id]: id }),
  {}
);

export const headings = {
  uploading: t("employees-section.ready-employees"),
  error: t("employees-section.error-employees"),
};
